import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const FacebookLogo = ({
  color = "#1877F2",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Facebook Logo</title>
    <path
      fill="currentColor"
      d="M128 64c0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64c0 31.944 23.404 58.421 54 63.223V82.5H37.75V64H54V49.9C54 33.86 63.555 25 78.174 25c7.002 0 14.326 1.25 14.326 1.25V42h-8.07C76.48 42 74 46.933 74 51.995V64h17.75l-2.838 18.5H74v44.723c30.596-4.802 54-31.279 54-63.223z"
    />
    <path
      fill="#fff"
      d="M88.912 82.5L91.75 64H74V51.995C74 46.934 76.48 42 84.43 42h8.07V26.25S85.176 25 78.174 25C63.554 25 54 33.86 54 49.9V64H37.75v18.5H54v44.723A64.51 64.51 0 0064 128a64.51 64.51 0 0010-.777V82.5h14.912z"
    />
  </Icon>
);

export default FacebookLogo;
